/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  EVBox, EVTypography, EVPaper, EVClickAwayListener,
} from '@eagleview/ev-comp-library';
import Notification from 'commonComponents/Notification';
import clsx from 'clsx';
import { connect, useDispatch } from 'react-redux';
import { getMessages, markMsgArchive } from './Notifications.action';
import useStyles from './NotificationsPopupStyles';

const NotificationPopup = (props) => {
  const {
    handleClickAway,
    notifications,
  } = props;

  const classes = useStyles();
  const dispatch = useDispatch();
  const getMsgs = (payload) => dispatch(getMessages(payload));
  const handleArchiveClick = (payload) => dispatch(markMsgArchive(payload));
  useEffect(() => {
    getMsgs({ userId: 'manish.j@ev.com' });
  }, []);

  const Header = () => (
    <EVBox className={clsx(classes.header)}>
      <EVTypography className={clsx(classes.headerText)}>Notifications</EVTypography>
      <EVTypography className={clsx(classes.dayText)}>Last 7 days</EVTypography>
    </EVBox>
  );

  return (
    <EVClickAwayListener onClickAway={handleClickAway}>
      <EVPaper className={classes.paper} elevation={6}>
        <Header id="notificationHeader" />
        <EVBox className={clsx(classes.notificationListBox)}>
          {notifications.map((notification) => (
            !notification.archived
            && (
            <Notification
              templateContent={notification.templateContent}
              handleArchiveClick={() => handleArchiveClick({ notificationId: notification.id })}
            />
            )
          ))}
        </EVBox>
      </EVPaper>
    </EVClickAwayListener>
  );
};

/**
 * selects required data from redux store
 * @param {Object} state - redux store object
 */
const selector = (state) => ({
  notifications: state.Notifications.notifications,
});

NotificationPopup.propTypes = {
  handleClickAway: PropTypes.func,
  notifications: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    userId: PropTypes.string,
    organizationId: PropTypes.string,
    eventId: PropTypes.string,
    templateContent: PropTypes.string,
    read: PropTypes.bool,
    archived: PropTypes.bool,
    eventData: PropTypes.shape(),
    meta: PropTypes.shape(),
  })),
};

NotificationPopup.defaultProps = {
  handleClickAway: () => {},
  notifications: [],
};

export { NotificationPopup };
export default connect(selector, {})(NotificationPopup);
